import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { WorkOrderService } from "../../services/work-order.service";
import { LocalDataSource } from "ng2-smart-table";
import * as moment from "moment";
import { Router, ActivatedRoute } from "@angular/router";
import * as fileSaver from "file-saver";
import { ProjectService } from "../../services/project.service";
import { ReportesService } from "../../services/reportes.service";
import { ListofvaluesService } from "../../services/listofvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { AlertComponent } from "../../../shared";
import { NotifierService } from "../../shared/notifier/notifier.service";
import { UserService } from "../../services/usuario.service";
import { ReportClientPieceDialogComponent } from "../report-client-piece-dialog/report-client-piece-dialog.component";
import { BillingService } from "../../services/billing.service";
import { ReportFullPieceOtDialogComponent } from "../report-full-piece-ot-dialog/report-full-piece-ot-dialog.component";

@Component({
  selector: "app-work-order-list",
  templateUrl: "work-order-list.component.html",
  styleUrls: ["work-order-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    WorkOrderService,
    ListofvaluesService,
    BillingService,ReportesService,
    ProjectService,
  ],
})
export class WorkOrderListComponent implements OnInit {

  selectedItemCount: number = 0;
  selectedRow: any[] = [];
  listaId: any[] = [] ;
  fechaInicio: string;
  fechaFinal: string;

  selectedRows1: any = [];
  selectedRows2: any = [];
  tableSettingsWorkOrder: any = undefined;
  workOrderData: IWorkOrder;
  dataSourceWorkOrder: any = undefined;
  tableDataWorkOrder: any = {};
  //Para ot's archivados
  dataSourceArchivedWorkOrder: any = undefined;
  archivedTableSettingsWorkOrder: any = undefined;
  tableArchivedDataWorkOrder: any = {};
  showArchived: Boolean = false;
  totalDias = "";
  showMenu: Boolean = false;
  datoEstado;
  listaStates: any = {};
  /////////////////////////////////////////
  rolParaValidar = this.readLocalStorageValue("rolIdUser") || 0;

  perPage = 10;
  ldvWorkOrderState: any;
  budget_detail_data: any;
  settings = {
    selectMode: "multi",
    pager: { display: true, perPage: this.perPage },
    noDataMessage: "No hay datos que mostrar.",
    columns: undefined,
    actions: {
      add: false,
      delete: false,
      position: "right",
      edit: false,
      columnTitle: "Acciones",
      custom: [],
    },
  };
  constructor(
    private billingService: BillingService,
    private reporteService: ReportesService,
    private workOrderService: WorkOrderService,
    private projectService: ProjectService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private userService: UserService,
    public router: Router,

    private listofvalues: ListofvaluesService,
    private notifierService: NotifierService
  ) {

    let miRol =   localStorage.getItem("rolIdUser");
    if (miRol == "4"){
      this.showMenu = true;
    }
    this.settings.actions.custom = [];
    this.settings.actions.custom.push({ name: "editar", title: `<div class="editCustomButton">Editar</div>` },);
    if (this.rolParaValidar == 4 || this.rolParaValidar == 5) {
        this.settings.actions.custom.push({
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        });
    }

    this.activatedRoute.params.subscribe((params) => {
      if (params["jwt"]) {
        localStorage.setItem("jwt", params["jwt"]);
      }

    });
    let estado = localStorage.getItem("tipo");
    if (estado) {
      this.getWorkOrdersDataZero(estado);
      if (estado == "0") this.router.navigate([`/system/work-order/list`]);
      else {
        this.router.navigate([`/system/work-order/list-${estado}`]);
      }
    } else {
      this.getWorkOrdersDataZero(0);
      this.router.navigate([`/system/work-order/list`]);
    }

    this.listofvalues
      .getLdvByCode("TBWA-STATE-WORKORDER")
      .subscribe((state) => {
        this.listaStates = state;
        // this.datoEstado = [];
        //this.listaStates.forEach(element => {
        //this.datoEstado.push({'value': element['value'], 'title': element['value']})

        //});
      });

    this.tableDataWorkOrder = {
      columns: {
        external_code: { title: "Código" },
        project: { title: "Proyecto" },
        product_description: { title: "Descripción" },
        aperture_date: { title: "Fecha de Apertura" },
        closed: {
          title: "Estado de Orden",
          filter: {
            type: "list",
            config: {
              selectText: "Seleccionar",
              list: [
                { value: "Abierto", title: "Abierto" },
                { value: "Cerrado", title: "Cerrado" },
              ],
            },
          },
        },
        state_name: {
          title: "Estado de Proceso",
          filter: {
            type: "list",
            config: {
              selectText: "Seleccionar",
              //list: this.datoEstado,
              list: [
                { value: "Abierta", title: "Abierta" },
                { value: "Cerrada", title: "Cerrada" },
              ],
            },
          },
        },
      },
      data: {},
    };
  }

  typeOrder: string | number;
  cargar = false;

  ngOnInit() {
    this.tableSettingsWorkOrder = this.copyObject(this.settings);

    this.llamarFuncion();
  }

  carga0 = false;
  carga1 = false;
  carga2 = false;
  llamarFuncion() {
    let fee = localStorage.getItem("tipo");
    this.typeOrder = this.readLocalStorageValue("tipo");

    if (this.typeOrder == "0") {
      this.carga0 = true;
      this.carga1 = false;
      this.carga2 = false;
    }
    if (this.typeOrder == "1") {
      this.carga0 = false;
      this.carga1 = true;
      this.carga2 = false;
    }
    if (this.typeOrder == "2") {
      this.carga0 = false;
      this.carga1 = false;
      this.carga2 = true;
    }
  }

  readLocalStorageValue(key: string): string {
    return localStorage.getItem(key);
  }

  getWorkOrdersDataZero(tipe) {
    this.cargar = false;
    localStorage.setItem("tipo", tipe);
    this.llamarFuncion();

    this.getTableData([]);
    this.workOrderService
      .getAllWorkOrders(tipe)
      .subscribe((result: Array<IWorkOrder>) => {
        var arr = [];

        let m = moment();
        let fechaActual = m.locale("es");

        result.forEach((element) => {
          var totalDias = element.dias;
          //  if(totalDias===null){

          element.dias = this.restaFechas(
            moment(element.aperture_date).format("DD/MM/YYYY"),
            moment(fechaActual).format("DD/MM/YYYY")
          );

          if (element.dias > 90) {
            element.colorAviso = "r-rojo";
          }
          if (element.state_workflow != 5) {
            arr.push(element);
          }
        });
        this.listofvalues
          .getLdvByCode("TBWA-STATE-WORKORDER")
          .subscribe((state) => {
            this.ldvWorkOrderState = state;
            this.getTableData(arr);
            this.cargar = true;
          });
      });
  }

  // getWorkOrdersDataOne() {
  //   this.getTableData([]);
  //   this.workOrderService
  //     .getAllWorkOrders(1)
  //     .subscribe((result: Array<IWorkOrder>) => {
  //       var arr = [];

  //       let m = moment();
  //       let fechaActual = m.locale("es");

  //       result.forEach((element) => {
  //         var totalDias = element.dias;
  //         //  if(totalDias===null){

  //         element.dias = this.restaFechas(
  //           moment(element.aperture_date).format("DD/MM/YYYY"),
  //           moment(fechaActual).format("DD/MM/YYYY")
  //         );

  //         if (element.dias > 90) {
  //           element.colorAviso = "r-rojo";
  //         }

  //         if (element.state_workflow != 5) {
  //           arr.push(element);
  //         }
  //       });
  //       console.log("Work Orders ->", arr);
  //       this.listofvalues
  //         .getLdvByCode("TBWA-STATE-WORKORDER")
  //         .subscribe((state) => {
  //           this.ldvWorkOrderState = state;
  //           this.getTableData(arr);
  //         });
  //     });
  // }

  // getWorkOrdersDataTwo() {
  //   this.getTableData([]);
  //   this.workOrderService
  //     .getAllWorkOrders(2)
  //     .subscribe((result: Array<IWorkOrder>) => {
  //       var arr = [];

  //       let m = moment();
  //       let fechaActual = m.locale("es");

  //       result.forEach((element) => {
  //         var totalDias = element.dias;
  //         //  if(totalDias===null){

  //         element.dias = this.restaFechas(
  //           moment(element.aperture_date).format("DD/MM/YYYY"),
  //           moment(fechaActual).format("DD/MM/YYYY")
  //         );

  //         if (element.dias > 90) {
  //           element.colorAviso = "r-rojo";
  //         }

  //         if (element.state_workflow != 5) {
  //           arr.push(element);
  //         }
  //       });
  //       console.log("Work Orders ->", arr);
  //       this.listofvalues
  //         .getLdvByCode("TBWA-STATE-WORKORDER")
  //         .subscribe((state) => {
  //           this.ldvWorkOrderState = state;
  //           this.getTableData(arr);
  //         });
  //     });
  // }

  openReportClientPieceDialog() {
    this.dialog.open( ReportClientPieceDialogComponent );
  }


  exportarFullPiezasInfoPorOts() {

    if (this.listaId.length == 0) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Se requiere seleccionar al menos una OT",
        type: 'error',
        duration: 5000
      });
      return;
    }

    this.dialog.open( ReportFullPieceOtDialogComponent, {
      data: {
        arrIdOts: this.listaId
      }
    });

    
  }
  

  exportExcel() {
    let headerData;
    let copyData;
    headerData = [
      { dataBound: "external_code", name: "Código", width: 40 },
      { dataBound: "project", name: "Proyecto", width: 20 },
      { dataBound: "product_description", name: "Descripcion", width: 30 },
      { dataBound: "aperture_date", name: "Fecha de apertura", width: 30 },
      { dataBound: "closed", name: "Estado de orden", width: 30 },
      { dataBound: "state_name", name: "Estado de proceso", width: 30 },
    ];
    const data = this.dataSourceWorkOrder.filteredAndSorted;
    copyData = this.dataSourceWorkOrder.filteredAndSorted;
    const nameProyect = "Reporte hora por cliente";

    const options = {
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      useBom: true,
      headers: [
        "Código",
        "Proyecto",
        "Descripcion",
        "Fecha de apertura",
        "Estado de orden",
        "Estado de proceso",
      ],
    };
    this.reporteService
      .exportExcel(headerData, copyData)
      .subscribe((result) => {
        const mediaType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([result._body], { type: mediaType });
        const fileName = "Reporte";
        fileSaver.saveAs(blob, fileName);
      });
  }

  prepareProfilePicCell(cell, row): string {
    if (cell) {
      return `<div class='text-rigth ${row.colorAviso}'>${cell}</div>`;
    } else {
      return "";
    }
  }

  restaFechas(f1, f2) {
    var aFecha1 = f1.split("/");
    var aFecha2 = f2.split("/");
    var fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
    var fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
    var dif = fFecha2 - fFecha1;
    var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
    return dias;
  }

  getTableData(result) {
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {
      item.aperture_date = moment(item.aperture_date).format("DD/MM/YYYY");
      item.closed = item.closed == 1 ? "Cerrado" : "Abierto";

      for (const v of this.ldvWorkOrderState) {
        // tslint:disable-next-line:triple-equals
        if (item.state_workflow == v.ref1) {
          item.state_name = v.value;
        }
      }
    }

    this.dataSourceWorkOrder = new LocalDataSource(cloneRows);
    this.tableSettingsWorkOrder = this.copyObject(this.settings);
    if (this.tableDataWorkOrder.columns !== undefined) {
      this.tableSettingsWorkOrder.columns = this.copyObject(
        this.tableDataWorkOrder.columns
      );

      //this.tableSettingsWorkOrder.columns.dias.valuePrepareFunction = this.prepareProfilePicCell;
      //this.tableSettingsWorkOrder.columns.dias.type = 'html';

      this.tableSettingsWorkOrder.columns.aperture_date.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.aperture_date.type = "html";

      this.tableSettingsWorkOrder.columns.closed.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.closed.type = "html";

      this.tableSettingsWorkOrder.columns.external_code.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.external_code.type = "html";

      this.tableSettingsWorkOrder.columns.product_description.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.product_description.type = "html";

      this.tableSettingsWorkOrder.columns.project.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.project.type = "html";

      this.tableSettingsWorkOrder.columns.state_name.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsWorkOrder.columns.state_name.type = "html";

      // Se deshabilita los filtros predefinidos para evitar conflictos
      if (!this.tableSettingsWorkOrder.columns["closed"]) {
        Object.keys(this.tableSettingsWorkOrder.columns).forEach((key) => {
          this.tableSettingsWorkOrder.columns[key].filter = true;
        });
      }
    }
    console.log(this.dataSourceWorkOrder);
    console.log(this.tableSettingsWorkOrder);

    if (
      localStorage.getItem("filter-work-order") != "" &&
      localStorage.getItem("filter-work-order")
    ) {
      var elem = JSON.parse(localStorage.getItem("filter-work-order"));
      if (cloneRows.length > 0) {
        this.dataSourceWorkOrder.setFilter(elem.filters);
        localStorage.setItem("filter-work-order", "");
      }
    }
  }

  customWorkOrderAction(event) {
    switch (event.action) {
      case "editar":
        localStorage.setItem(
          "filter-work-order",
          JSON.stringify(this.dataSourceWorkOrder.getFilter())
        );

        this.route.navigate(["/system/work-order/edit", event.data.id]);
        break;
      case "eliminar":
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: `¿Está seguro que desea eliminar la Orden de Trabajo?
            \n Recuerde que las OT Abiertas son las únicas que se pueden eliminar`,
            options: true,
          },
        });
        deleteDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              this.workOrderService
                .deleteWorkOrder(event.data.id)
                .subscribe((deleteResult) => {
                  this.notifierService.systemNotify({
                    title: "Éxito",
                    message: "Se ha eliminado la Orden de Trabajo con éxito",
                    type: "success",
                  });
                  //this.ngOnInit();
                  this.getWorkOrdersDataZero( isNaN(Number(localStorage.getItem("tipo"))) ? 0 : Number(localStorage.getItem("tipo")));
                });
            }
          },
          (error) => {
            console.log("error", error);
            this.notifierService.systemNotify({
              title: "Error",
              message: "No se ha podido eliminar la Orden de Trabajo",
              type: "error",
            });
            this.ngOnInit();
          }
        );
        break;
      case "return": {
        let reactivateDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea reactivar la Orden de trabajo?",
            options: true,
          },
        });
        this.workOrderService
          .getWorkOrder(event.data.id)
          .subscribe((ot: IWorkOrder) => {
            ot.state_workflow = 1;
            this.workOrderData = ot;
          });
        reactivateDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.workOrderService.updateWorkOrder(this.workOrderData).subscribe(
              () => {
                this.notifierService.systemNotify({
                  title: "Exito",
                  message:
                    "Se ha desarchivado la Orden de trabajo, puede verlo en la sección de Ordenes de trabajo",
                  type: "success",
                });
                this.ChangeLists();
                this.route.navigate(["/system/work-order/list"]);
              },
              (error) => {
                this.notifierService.systemNotify({
                  title: "Error",
                  message: error.result.message,
                  type: "success",
                });
              }
            );
          }
        });

        break;
      }
    }
  }

  //CHANGE LIST

  loadArchiveData() {
    this.tableArchivedDataWorkOrder = {
      columns: {
        external_code: { title: "CÓDIGO" },
        project: { title: "PROYECTO" },
        product_description: { title: "DESCRIPCIÓN" },
        aperture_date: { title: "FECHA DE APERTURA" },
        state_workflow: { title: "ESTADO DE ORIGEN" },
        closed: { title: "ESTADO DE PROCESO" },
      },
      data: {},
    };
    this.archivedTableSettingsWorkOrder = this.copyObject(this.settings);
    delete this.archivedTableSettingsWorkOrder.selectMode;
    this.archivedTableSettingsWorkOrder.actions.custom = [
      {
        name: "return",
        title: `<div class="editCustomButton">Reactivar OT</div>`,
      },
    ];

    //Se valida si se pudo obtener la lista
    if (this.tableArchivedDataWorkOrder.columns != undefined) {
      this.archivedTableSettingsWorkOrder.columns = this.copyObject(
        this.tableArchivedDataWorkOrder.columns
      );
      //Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.archivedTableSettingsWorkOrder.columns).forEach(
        (key) => {
          this.archivedTableSettingsWorkOrder.columns[key].filter = true;
        }
      );
    }

    this.workOrderService
      .getArchivedWorkOrders(localStorage.getItem("tipo"))
      .subscribe(
        (result) => {
          this.tableArchivedDataWorkOrder.data = result;
          for (let item of this.tableArchivedDataWorkOrder.data) {
            item.aperture_date = moment(item.aperture_date).format(
              "DD/MM/YYYY"
            );
            item.closed = item.closed == 1 ? "Cerrado" : "Abierto";
            item.state_workflow =
              item.state_workflow === 5 ? "ARCHIVADO" : "Abierto";
          }
          // Se crea el dataSource y se setea las configs
          this.dataSourceArchivedWorkOrder = new LocalDataSource(
            this.tableArchivedDataWorkOrder.data
          );
          //Muestra la imagen en la celda (en vez de mostrar el ID del attachment)
        },
        (error) => {
          this.dataSourceArchivedWorkOrder = undefined;
          console.log("error", error);
        }
      );
  }

  ChangeLists() {
    this.showArchived = !this.showArchived;
    if (this.showArchived) {
      this.loadArchiveData();
    } else {
      this.getWorkOrdersDataZero(localStorage.getItem("tipo"));
    }
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  onUserRowSelect1(event: any) {
    this.selectedRows1 = event.selected;
  
    if (event.isSelected) {
      // Agregar fila seleccionada
      this.selectedRow.push({ ...event.data, isSelected: true });
      this.selectedItemCount = this.selectedRow.length;
  
      // Obtener los IDs de la lista
      this.listaId = this.selectedRow.map(row => row.id);
    } else {
      // Eliminar fila deseleccionada
      const index = this.selectedRow.findIndex(row => row.id === event.data.id);
  
      if (this.selectedRows1 != null || this.selectedRows1 != "") {
        this.selectedItemCount = this.selectedRows1.length;
  
        // Obtener los IDs de la lista
        this.listaId = this.selectedRows1.map(row => row.id);
      }
  
      if (index !== -1) {
        this.selectedRow.splice(index, 1);
        this.selectedItemCount = this.selectedRow.length;
  
        // Obtener los IDs de la lista
        this.listaId = this.selectedRow.map(row => row.id);
      }
    }
  }
  
  
    onUserRowSelect2(event) {
      this.selectedRows2 = event.selected;
    
      if (event.isSelected) {
        // Agregar fila seleccionada
        this.selectedRow.push(event.data);
        this.selectedItemCount = this.selectedRow.length;
    
        // Obtener los IDs de la lista
        this.listaId = this.selectedRow.map(row => row.id);
      } else {
        // Eliminar fila deseleccionada
        const index = this.selectedRow.findIndex(row => row.id === event.data.id);
    
        if (this.selectedRows2 != null || this.selectedRows2 != "") {
          this.selectedItemCount = this.selectedRows2.length;
    
          // Obtener los IDs de la lista
          this.listaId = this.selectedRows2.map(row => row.id);
        }
    
        if (index !== -1) {
          this.selectedRow.splice(index, 1);
          this.selectedItemCount = this.selectedRow.length;
    
          // Obtener los IDs de la lista
          this.listaId = this.selectedRow.map(row => row.id);
        }
      }
    }
    

  archivarMultiple1() {
    var n = this.selectedRows1.length;
    if (n == 0) {
      const aviso = this.dialog.open(AlertComponent, {
        data: {
          icon: "exclamation-circle",
          iconColor: "failure",
          title: "Aviso",
          text: "Seleccione mínimo un documento",
          options: false,
        },
      });
      aviso.afterClosed().subscribe((_) => {});
      return;
    }

    const archivarDialog = this.dialog.open(AlertComponent, {
      data: {
        icon: "exclamation-circle",
        iconColor: "failure",
        title: "Aviso",
        text: "¿Está seguro que desea archivar los " + n + " presupuestos?",
        options: true,
      },
    });

    archivarDialog.afterClosed().subscribe(
      (result) => {
        if (result) {
          const hayAbiertos = this.selectedRows1.some(
            (wo) =>
              wo.state_workflow != 2 || wo.state_name != "CERRADA"
          );

          if (hayAbiertos) {
            const aviso = this.dialog.open(AlertComponent, {
              data: {
                icon: "exclamation-circle",
                iconColor: "failure",
                title: "Aviso",
                text: "Por favor seleccione solo órdenes de trabajo cerradas para poder archivarlas",
                options: false,
              },
            });
            aviso.afterClosed().subscribe((_) => {});
            return;
          }

          this.projectService
            .archivarMultipleProject(this.selectedRows1)
            .subscribe((result) => {
              this.notifierService.systemNotify({
                title: "Éxito",
                message: "Se han archivado los proyectos",
                type: "success",
              });

              this.getWorkOrdersDataZero(localStorage.getItem("tipo"));
            }),
            (err) => {
              console.log("error", err);
              this.notifierService.systemNotify({
                title: "Ha ocurrido un error",
                message: err.result.message,
                type: "error",
              });
            };

          this.workOrderService
            .archivarMultiple(this.selectedRows1)
            .subscribe((result) => {
              this.notifierService.systemNotify({
                title: "Éxito",
                message: "Se han archivado las Ordenes de trabajo",
                type: "success",
              });

              this.getWorkOrdersDataZero(localStorage.getItem("tipo"));
            }),
            (err) => {
              console.log("error", err);
              this.notifierService.systemNotify({
                title: "Ha ocurrido un error",
                message: err.result.message,
                type: "error",
              });
            };
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  archivarMultiple2() {
    var n = this.selectedRows2.length;
    if (n == 0) {
      const aviso = this.dialog.open(AlertComponent, {
        data: {
          icon: "exclamation-circle",
          iconColor: "failure",
          title: "Aviso",
          text: "Seleccione mínimo un documento",
          options: false,
        },
      });
      aviso.afterClosed().subscribe((_) => {});
      return;
    }

    const archivarDialog = this.dialog.open(AlertComponent, {
      data: {
        icon: "exclamation-circle",
        iconColor: "failure",
        title: "Aviso",
        text: "¿Está seguro que desea archivar los " + n + " presupuestos?",
        options: true,
      },
    });

    archivarDialog.afterClosed().subscribe(
      (result) => {
        if (result) {
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }
}
export interface IWorkOrder {
  id?: number;
  external_code: string;
  client_id: number;
  product_description: string;
  project: string;
  aperture_date: Date;
  close_date?: Date;
  closed: boolean;
  state_workflow: number;
  create_date?: Date;
  update_date?: Date;
  create_user?: number;
  update_user?: number;
  tenant?: string;
  state_name?: string;
  client_comision?: number;
  fee?: number;
  client_doc_type?: string;
  dias?: number;
  colorAviso?: string;
  nombre_completo?: string;
  client_name?: string;
}



// WEBPACK FOOTER //
// ./src/app/system/work-order/work-order-list/work-order-list.component.ts